import styled from 'foundations-theming/utils';
export const StyledBodyField = styled.div.withConfig({
  displayName: "StyledBodyField",
  componentId: "gllsax-0"
})(({
  theme
}) => ({
  '.ProsemirrorEditor__wrapper': {
    padding: '9px 10px 9px !important',
    borderRadius: theme.borderRadius['100'],
    border: `${theme.borderWidth['100']} solid ${theme.color['border-core-default']}`,
    fontSize: theme.typography['body-200'].fontSize,
    transition: 'all 150ms ease-out',
    backgroundColor: theme.color['fill-field-default'],
    color: theme.color['text-core-default'],
    display: 'block',
    width: '100%',
    textAlign: 'left',
    verticalAlign: 'middle',
    minHeight: 'auto',
    '&.error': {
      border: `${theme.borderWidth['100']} solid ${theme.color['border-alert-default']} !important`,
      boxShadow: `0 0 0 1px ${theme.color['border-alert-default']} !important`,
      '&:focus, &.focused': {
        boxShadow: `0 0 2px 2px ${theme.color['border-alert-default']} !important`,
        outline: 0
      }
    },
    '&.focused': {
      borderColor: theme.color['border-interactive-default'],
      boxShadow: `0 0 4px 1px ${theme.color['border-interactive-default']}cc, 0 0 0 1px ${theme.color['border-interactive-default']}`,
      outline: 0
    },
    '.ProsemirrorEditor__body': {
      minHeight: '6rem',
      paddingBottom: theme.space['100'],
      fontFamily: theme.typography['body-200'].fontFamily,
      '*': {
        fontSize: `${theme.typography['body-200'].fontSize} !important`
      },
      '.ProseMirror': {
        minHeight: 'inherit'
      }
    }
  },
  '.ProseMirrorPlaceholder': {
    color: theme.color['text-core-subtle']
  },
  '.prosemirror-controls': {
    fontSize: theme.typography['body-100'].fontSize
  },
  '@media only screen and (max-width: 544px)': {
    '.ProsemirrorEditor__wrapper': {
      width: '100%'
    }
  }
}));